/** Texte lisible (blanc ou brun foncé) sur une couleur hex #rgb / #rrggbb ; undefined si non analysable. */
export function resolveTextOnColor(color?: string): string | undefined {
  const match = color?.trim().match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (!match) return undefined;
  const hex = match[1].length === 3 ? match[1].replace(/./g, (c) => c + c) : match[1];
  const [r, g, b] = [0, 2, 4].map((i) => {
    const channel = parseInt(hex.slice(i, i + 2), 16) / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  });
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  // Seuil d'équilibre des contrastes blanc / #3B1C13.
  return luminance > 0.22 ? 'var(--text-primary)' : 'var(--text-on-dark)';
}
